// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * AccountAttributes type.
 * @typedef {object} AccountAttributes
 * @property {string} id - Attribute value.
 * @property {string | null} name - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by AccountCreateAttributes.
 * @typedef {object} AccountCreateAttributes
 * @property {AccountAttributes["name"] | null} [name] - Permitted name value.
 */
/**
 * Attributes accepted by AccountUpdateAttributes.
 * @typedef {object} AccountUpdateAttributes
 * @property {AccountAttributes["name"] | null} [name] - Permitted name value.
 */
/**
 * Frontend model for Account.
 * @augments {FrontendModelBase<AccountAttributes, AccountCreateAttributes, AccountUpdateAttributes, AccountAttributes["id"], string>}
 */
class Account extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "Account",
      attributes: [
        "id",
        "name",
        "createdAt",
        "updatedAt",
      ],
    }
  }

  /** @returns {AccountAttributes["id"]} - Attribute value. */
  id() { return /** @type {AccountAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {AccountAttributes["id"] | null} newValue - New attribute value.
   * @returns {AccountAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {AccountAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {AccountAttributes["name"]} - Attribute value. */
  name() { return /** @type {AccountAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {AccountAttributes["name"] | null} newValue - New attribute value.
   * @returns {AccountAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {AccountAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {AccountAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {AccountAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {AccountAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {AccountAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(Account)

export {Account}

export default Account
